import useSWR from "swr"
import { CustodyTransferApi } from "../../../apis"

export function useCustodyTransferQuery(id: string | null | undefined) {
  return useSWR(
    id ? ["custody-transfer", id] : null,
    async () => CustodyTransferApi.get(id as string),
    { revalidateOnFocus: false },
  )
}
